export default __webpack_public_path__ + "static/media/val2.58a3ce1e.png";